/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na informace o připojení k síti.
 */
class NetworkConnectionFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<NetworkConnection>} NetworkConnection Konstruktor informací o připojení k síti.
   * @returns {NetworkConnectionFactory} Nová instance.
   */
  constructor (NetworkConnection) {
    this.NetworkConnection = NetworkConnection;
  }

  /**
   * Vytvoří informace o připojení k síti.
   * @param {string} mac MAC adresa.
   * @param {NetworkType} type Typ připojení.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {string} [opts.ip] IP adresa.
   * @returns {NetworkConnection} Vytvořené připojení.
   */
  create (mac, type, {ip} = {}) {
    return new this.NetworkConnection(mac, type, {ip});
  }
}

export default NetworkConnectionFactory;
